import React, { useState, useEffect } from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  PageTitle,
  showToast,
} from "../../../../../../components";
import Tektreelogo from "../../../../../../../src/assets/images/Tektree.png";
import CompanyInfoModal from "../CompanyProfileModals/CompanyInfoModal";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import { getOrganizationLocaleInfo } from "../../../../../../redux/slices/setting/settingApi";
import { ENDPOINTS } from "../../../../../../redux/apiConfig";
import { useSelector } from "react-redux";

const CompanyInfo = () => {
  const [primaryAccountEmail, setPrimaryAccountEmail] = useState([
    { email: "" },
  ]);

  const [billingEmail, setBillingEmail] = useState([{ email: "" }]);

  const { userData: loginUserData } = useLoginUser();

  const [editModalOpen, setEditModalOpen] = useState(false);

  const [orgData, setOrgData] = useState(null);
  const { user } = useSelector((state) => state?.auth);

  useEffect(() => {
    getOrganization();
  }, [editModalOpen]);

  const getOrganization = async () => {
    try {
      const res = await getOrganizationLocaleInfo({
        coll: "Organization",
        method: "GET",
        fil: {
          uiid: { type: "NONE", value: user?.data?.organizationId?.uiid },
        },
        url: ENDPOINTS.ORGANIZATIONS.GET,
      });

      const org = res?.data?.data;
      if (org) {
        setOrgData(org);
      }
    } catch (error) {
      console.error(error);
      showToast("Failed to fetch organization data", "error");
    }
  };

  const getFormattedAddress = () => {
    if (!orgData?.address) return "—";
    const { address1, address2, city, state, country, zipCode } =
      orgData.address;
    return [address1, address2, city, state, country, zipCode]
      .filter(Boolean)
      .join(", ");
  };

  const handlePrimaryChange = (index, val) => {
    const updated = [...primaryAccountEmail];
    updated[index].email = val;
    setPrimaryAccountEmail(updated);
  };

  const addPrimaryEmail = () => {
    if (primaryAccountEmail.length < 3) {
      setPrimaryAccountEmail([...primaryAccountEmail, { email: "" }]);
    }
  };

  const removePrimaryEmail = (index) => {
    if (primaryAccountEmail.length > 1) {
      setPrimaryAccountEmail(primaryAccountEmail.filter((_, i) => i !== index));
    }
  };
  const handleBillingChange = (index, val) => {
    const updated = [...billingEmail];
    updated[index].email = val;
    setBillingEmail(updated);
  };

  const addBillingEmail = () => {
    if (billingEmail.length < 3) {
      setBillingEmail([...billingEmail, { email: "" }]);
    }
  };

  const removeBillingEmail = (index) => {
    if (billingEmail.length > 1) {
      setBillingEmail(billingEmail.filter((_, i) => i !== index));
    }
  };

  const EmailList = ({ list, onChange, onAdd, onRemove }) => {
    return (
      <div className="flex flex-col gap-4 mt-4">
        {list.map((item, index) => (
          <div key={index} className="flex items-start gap-2">
            {/* Full width email field */}
            <div className="flex-grow">
              <FormFieldSet
                type="email"
                title="Email"
                placeholder="Enter Email"
                value={item.email}
                onChange={(e) => onChange(index, e.target.value)}
                shadow
              />
            </div>

            {/* Buttons */}
            <div className="flex gap-2 mt-8">
              {list.length < 3 && (
                <Button
                  type="icon"
                  icon="add"
                  size="xs"
                  color="black"
                  onClick={onAdd}
                />
              )}
              {list.length > 1 && (
                <Button
                  type="icon"
                  icon="remove"
                  size="xs"
                  color="danger"
                  onClick={() => onRemove(index)}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    );
  };

  return loginUserData?.role?.module === 4 ? (
    <div className="flex flex-col justify-center items-center flex-1 overflow-auto ">
      <div className="flex flex-col justify-center items-center m-10">
        <h1 className="flex font-bold text-center items-center  break-words">
          Company Info
        </h1>
        <h2 className="flex font-bold text-center items-center  break-words">
          Coming soon
        </h2>
      </div>
    </div>
  ) : (
    <div className="flex-grow p-4 xl:pr-20 pt-8">
      <PageTitle title={"Company Information"} tag="h6" />
      <div className="shadow-sm rounded-md py-6 px-4 flex flex-col lg:flex-row justify-between items-start lg:items-center my-5 gap-4">
        <div className="flex flex-col lg:flex-row gap-3 text-sm items-start lg:items-center flex-1">
          <div className="border rounded-md border-neutrals-200 shadow-sm flex-shrink-0">
            <img
              src={Tektreelogo}
              className="w-[100px] h-[45px] lg:w-[153px] lg:h-[69px]"
            />
          </div>

          <div className="text-md">
            <div>
              <b>Company Name : </b>
              <span>{orgData?.name || "—"}</span>
            </div>
            <div className="mt-1">
              <b>Company Address : </b>
              <span>{getFormattedAddress()}</span>
            </div>
          </div>
        </div>
        <Button
          title={"Edit"}
          variant="outlined"
          color="primary"
          icon={"edit_square"}
          size="sm"
          onClick={() => setEditModalOpen(true)}
        />
      </div>

      <PageTitle title={"Points of Contact"} tag="h6" />
      <div className="flex flex-col lg:flex-row gap-3 mt-3 flex-grow">
        {/* LEFT BOX */}
        <div className="border shadow-sm p-4 border-neutrals-100 rounded-md flex-grow">
          <div className="text-sm mb-1">Primary Account Contact</div>

          <div className="text-xs text-neutrals-700  mb-1">
            The main person working with the account on a daily basis.
          </div>
          <div className="text-xs text-neutrals-700 mb-1">
            This user will receive all important account notifications
            (including invoices, upgrades, renewals, etc..).
          </div>

          <PageTitle title={"Select a User"} tag="p" />
          <div className="2xl:w-[66%] mt-2">
            <FormFieldSet
              type="select"
              placeholder="select"
              title="This role is required and a user must always be assigned"
              shadow={true}
              color="text-neutrals-800"
            />
          </div>
          <div className="2xl:w-[70%]">
            <EmailList
              list={primaryAccountEmail}
              onChange={handlePrimaryChange}
              onAdd={addPrimaryEmail}
              onRemove={removePrimaryEmail}
            />
          </div>
        </div>

        {/* RIGHT BOX */}
        <div className="border shadow-sm p-4 border-neutrals-100 rounded-md flex-grow">
          <div className="text-sm mb-1">Billing Contacts</div>
          <div className="text-xs text-neutrals-700 mb-1">
            Send copies of invoices receipts, orders and other renewal
            notifications to these Tektree users.
          </div>
          <div className="2xl:w-[66%] mt-2">
            <FormFieldSet
              type="select"
              placeholder="select"
              noTitle
              shadow={true}
            />
          </div>
          <div className="2xl:w-[70%]">
            <EmailList
              list={billingEmail}
              onChange={handleBillingChange}
              onAdd={addBillingEmail}
              onRemove={removeBillingEmail}
            />
          </div>
        </div>
      </div>
      <div className="flex justify-end mt-10">
        <Button title={"Save"} />
      </div>
      <CompanyInfoModal
        editModalOpen={editModalOpen}
        setEditModalOpen={setEditModalOpen}
      />
    </div>
  );
};

export default CompanyInfo;
